import styled from "styled-components";

export const WrapperContent = styled.div`
  background-color: ${(props) => props.theme.colors.BlueHighlight};
`;